var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect, useState } from 'react';
import { Input, Range } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { STEP } from '@app/configs/calculator';
import formatAmount from '@modules/calculator/utils/formatAmount';
const RangeSelectAmount = ({ title, min, max, onSelect, loanAmount, errors, setErrors }) => {
    var _a, _b;
    const { t } = useTranslation();
    const [value, setValue] = useState(formatAmount(loanAmount));
    const validateAmount = (amount) => {
        if (amount > max) {
            setErrors((currentErrors) => (Object.assign(Object.assign({}, currentErrors), { amount: {
                    state: true,
                    message: `${t('financing.demo_calculator_max_amount')} ${formatAmount(max)}`,
                } })));
            return false;
        }
        if (amount < min) {
            setErrors((currentErrors) => (Object.assign(Object.assign({}, currentErrors), { amount: {
                    state: true,
                    message: `${t('financing.demo_calculator_min_amount')} ${formatAmount(min)}`,
                } })));
            return false;
        }
        if (amount % 10 !== 0) {
            setErrors((currentErrors) => (Object.assign(Object.assign({}, currentErrors), { amount: {
                    state: true,
                    message: t('financing.demo_calculator_invalid_amount', { step: formatAmount(STEP) }),
                } })));
            return false;
        }
        setErrors((_a) => {
            var { amount: amountErrors } = _a, restErrors = __rest(_a, ["amount"]);
            return (Object.assign({}, restErrors));
        });
        return true;
    };
    useEffect(() => {
        setValue(formatAmount(loanAmount));
        validateAmount(loanAmount);
    }, [loanAmount]);
    const handleBlur = (event) => {
        var _a, _b;
        // Display uses en-US grouping ("€4,000"); inputs are stepped to whole units, so commas are always thousands separators.
        const enteredValue = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.replace(/[€\s,]/g, '');
        const enteredNumber = parseFloat(enteredValue);
        if (Number.isNaN(enteredNumber)) {
            setValue(formatAmount(min));
            return;
        }
        if (!validateAmount(enteredNumber)) {
            setValue(formatAmount(enteredNumber));
            return;
        }
        setValue(formatAmount(enteredNumber));
        onSelect(enteredNumber);
    };
    const handleChange = (event) => {
        var _a;
        const newValue = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value;
        const sanitizedValue = newValue.replace(/[^0-9.,€\s]/g, '');
        setValue(sanitizedValue);
    };
    return (<div className="flex flex-col gap-2">
            <div className="label-m">{title}</div>
            <Input id="inputAmount" onBlur={handleBlur} onChange={handleChange} label={t('financing.active_loan.amount')} value={value} isError={!!((_a = errors === null || errors === void 0 ? void 0 : errors.amount) === null || _a === void 0 ? void 0 : _a.state)} hintText={(_b = errors === null || errors === void 0 ? void 0 : errors.amount) === null || _b === void 0 ? void 0 : _b.message}/>
            <Range min={min} max={max} marks={[
            {
                label: `${t('financing.demo_calculator_min')}: ${formatAmount(min)}`,
                value: min,
            },
            {
                label: `${t('financing.demo_calculator_max')}: ${formatAmount(max)}`,
                value: max,
            },
        ]} onChange={onSelect} value={loanAmount} step={STEP}/>
        </div>);
};
export default RangeSelectAmount;
